<template>
  <div class="search-item-container search-item-twitter">
    <!-- HEADER -->
    <div class="search-item-header">
      <div class="search-item-title">
        <h4>
          <a :href="item.liveUrl" target="_blank">{{ item.title }}</a>
        </h4>
      </div>
      <div class="search-item-link">
        <a :href="item.liveUrl" target="_blank">{{ item.displayUrl }}</a>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="search-item-content">
      <img
        :src="item.metaData.image"
        :alt="'Thumbnail for ' + item.title"
        v-if="item.metaData && item.metaData.image"
      />
      <span class="search-item-date">{{ item.date }} </span>{{ item.summary }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchItemTwitter",
  computed: {
    collection() {
      return this.item.collection;
    },
  },
  props: {
    item: {
      type: Object,
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// searchItemTwitter.vue?7ccde5f2